import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';

const CARD_GAP = 15;

/**
 * In free mode the track can rest between two slides. Swiper's own loopFix
 * snaps to a slide when it rebalances the track at the next drag or click,
 * which shows as a jump. Rebalancing as soon as the track settles keeps the
 * sub-slide offset (byMousewheel path) and leaves nothing to fix later.
 *
 * @param {Swiper} swiper Row instance.
 */
const rebalanceFreeModeLoop = (swiper) => {
  if (swiper.destroyed || swiper.animating || !swiper.params.freeMode.enabled) {
    return;
  }

  swiper.loopFix({ byMousewheel: true });
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
};

domReady(() => {
  document.querySelectorAll('.partners').forEach((block) => {
    const nextEl = block.querySelector('.vtx-swiper__next');
    const prevEl = block.querySelector('.vtx-swiper__prev');

    block.querySelectorAll('.partners__row.swiper').forEach((el) => {
      const slides = el.querySelectorAll('.swiper-slide').length;
      // Repeated copies (aria-hidden) only pad the loop: announce the real count.
      const realSlides = el.querySelectorAll(
        '.swiper-slide:not([aria-hidden="true"])'
      ).length;

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: CARD_GAP,
        grabCursor: true,
        // Also drag from the gaps between cards, outside the translated wrapper.
        touchEventsTarget: 'container',
        loop: true,
        // Widest buffer loop mode allows (a third of the track on each side),
        // so a free-mode fling seldom reaches the end of the track.
        loopedSlides: Math.floor(slides / 3),
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl,
          prevEl,
        },
        breakpoints: {
          768: {
            freeMode: {
              enabled: true,
              momentum: true,
              momentumBounce: false,
            },
          },
        },
        a11y: {
          enabled: true,
          scrollOnFocus: true,
          prevSlideMessage: _x(
            'Go to previous slide',
            'swiper accessibility',
            'vtx'
          ),
          nextSlideMessage: _x(
            'Go to next slide',
            'swiper accessibility',
            'vtx'
          ),
          slideLabelMessage: _x(
            'Slide {{index}} of {{slidesLength}}',
            'swiper accessibility',
            'vtx'
          ).replace('{{slidesLength}}', realSlides),
        },
        on: {
          transitionEnd: rebalanceFreeModeLoop,
          touchEnd(swiper) {
            requestAnimationFrame(() => rebalanceFreeModeLoop(swiper));
          },
        },
      });
    });
  });
});
